import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
import { UserViewModel } from 'src/app/models/users/user-view.model';
import { ConfirmDeleteModalComponent } from '../../core/components/delete-modal/confirm-delete-modal-component';
import { ApplicationConfigService } from '../../core/services/application-config.service';
import { UserService } from '../../core/services/user.service';

type getColumnValue = (user: UserViewModel) => number | string | undefined;
type Column = { property: getColumnValue, title: string, textRight?: boolean, canSort?: boolean };
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  providers: [UserService]
})
export class UsersComponent implements OnInit {

  @ViewChild(ConfirmDeleteModalComponent, {static: false}) confirmDeleteModal: ConfirmDeleteModalComponent;

  searchText?: string;
  scrollConfig = {
    suppressScrollX: false,
    suppressScrollY: true
  };

  users: UserViewModel[];
  filteredUsers: UserViewModel[];
  pageUsers: UserViewModel[];

  columns: Column[] = [
    {title: 'Name', property: c => c.firstName, canSort: true},
    {title: 'Username', property: c => c.username, canSort: true},
    {title: 'Role', property: c => c.userRole, canSort: true}
  ];

  sortColumn = this.columns[0];
  sortAsc = true;
  pageSize: number;
  page = 1;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appConfigService: ApplicationConfigService,
    private userService: UserService) { }

  ngOnInit() {
    this.pageSize = this.appConfigService.userListPageSize;
        this.route.data.subscribe(data => {
            this.users = data.users || [];
            this.filterUpdated();
        });

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
  }

  filterUpdated() {
    let searchText = this.searchText ? this.searchText.toLowerCase() : '';
    this.filteredUsers = this.users.filter(user => {
        if (searchText === '') return true;
        return (user.firstName.toLowerCase().includes(searchText) || user.lastName.toLowerCase().includes(searchText));
    });
    this.sort();
  }

  sort(column?: Column) {
    if (column && !column.canSort) return;

    if (column === this.sortColumn)
        this.sortAsc = !this.sortAsc;

    if (column)
        this.sortColumn = column;
    this.filteredUsers = ArrayHelper.sortBy(this.filteredUsers, this.sortAsc, this.sortColumn.property);
    this.pageChange(this.page);
  }

  pageChange(page: number) {
    this.page = page;
    let start = this.pageSize * (page - 1);
    let end = this.pageSize * page;
    this.pageUsers = this.filteredUsers.slice(start, end);
  }

  async showDeleteConfirmModal(user: UserViewModel){
    let result = await this.confirmDeleteModal.showAwait();
    if (result){
        await this.userService.deleteUser(user.id.toString());
        this.users = await this.userService.getUsers();
        this.filterUpdated();
    }
  }

  async updatePageSize(){
    await this.appConfigService.updateUserPageSize(this.pageSize);
    setTimeout(() => {
        this.page = 1;
        this.pageChange(this.page);
        this.filterUpdated();
    });
  }

}
